import {
  // Message,
  LoadingBar,
} from 'view-design';
import Vue from 'vue';
import VueRouter from 'vue-router';
// import { userInfo } from '@/common/utils';
import store from '@/store/index';
// import { delParam } from '@/common/utils';
// 配置文件
import configEnv from '@/config';
// 加载router下的模块路由
const files = require.context('./router', false, /\.js$/);
const routeModel = [];
files.keys().forEach(key => {
  routeModel.push(...files(key).default);
});

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/layout',
  //   name: 'Layout',
  //   component: () => import('@/views/Layout.vue'),
  //   children: [
  //     ...menuRoutes,
  //   ],
  // },
  ...routeModel,
  // {
  //   path: '/main/Layout',
  //   component: () => import('@/views/main/Layout.vue'),
  //   children: [
  //     ...routeModel,
  //   ],
  // },
  // ...routeModel,
  // ...menuRoute,
  // ...developerCenter,
  // ...account,
  {
    path: '/404',
    name: '404',
    meta: {
      title: '页面丢失',
      checkLogin: false,
    },
    component: () => import('@/views/main/404.vue'),
  },
  {
    path: '/iframeBlank',
    name: 'iframeBlank',
    meta: {
      title: '',
      checkLogin: false,
    },
    component: () => import('@/views/main/iframeBlank.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const goLogin = ({
  to,
  from,
})=>{
  let redirectUrl = window.location.origin+to.fullPath;
  // 登录成功之后是否跳转到当前页面
  if (from.meta.isfromRedirectUrl){
    redirectUrl = window.location.origin+from.fullPath;
  }
  window.location.href = `${configEnv.userDomian}/usercenter/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
};

router.beforeEach(async (to, from, next) => {
  LoadingBar.start();
  let title = '智游宝商业中心';
  if (to.meta.title) {
    title = `${ to.meta.title}-${title}`;
  }
  document.title = title;
  // 该系统会嵌入第三方app中，
  // 初始进入该系统时要在路径中传corpName、corpCode、orderSource
  const {token} = to.query;
  if (token){
    // token存入缓存
    store.commit('setUserInfo',{ token});
    // 获取用户信息
    await store.dispatch('getUserInfo',{...to});
  }
  const {
    userInfo,
    // refreshed
  } = store.state.user;
  // 刷新的时候corpList会被清除
  // 刷新页面的时候重新获取用户信息
  // if (userInfo.token && !refreshed){
    // 这段代码会造成打开新页面时，企业与上个页面选择的企业不一致
  //   console.log('重新获取用户信息');
  //   await store.dispatch('getUserInfo');
  // }
  // 不需要登录检测的
  if (!to.meta.checkLogin) {
    return next();
  }
  // 是否已登录
  if (userInfo && userInfo.token) { // 本地获取了token说明用户登录过了
    if (to.matched.length) {
      // 有匹配到路由
      next();
    } else {
      next('/404');
    }
  } else {
    // 去用户中心登录
    goLogin({
      to,
      from,
    });
  }
});
router.afterEach(() => {
  LoadingBar.finish();
  window.scrollTo(0, 0);
});





export default router;
